module.exports = __webpack_public_path__ + "img/1 (4).b92e1d8d.jpg";